<template>
  <div class="login__content">
    <form v-if="resetPassword" class="w-full" @submit.prevent="loginUser()">
      <h2 class="login__title">
        Ingresar a mi <br />
        cuenta
      </h2>
      <div class="input-group w-full">
        <input
          v-model="user.email"
          v-validate="'required|email'"
          type="email"
          name="email"
          placeholder="E-MAIL"
          @focusout="changeStateInput($event)"
        />
      </div>
      <div class="input-group w-full">
        <span
          v-if="errors.has('email')"
          class="pl-1 text-red mt-2 font-neue text-sm"
          >{{ errors.first("email") }}</span
        >
      </div>
      <div class="input-group w-full">
        <input
          v-model="user.password"
          v-validate="'required'"
          type="password"
          name="password"
          placeholder="CONTRASEÑA"
          minlength="6"
          @focusout="changeStateInput($event)"
        />
      </div>
      <div class="input-group w-full">
        <span
          v-if="errors.has('password')"
          class="pl-1 text-red mt-2 font-neue text-sm"
          >{{ errors.first("password") }}</span
        >
      </div>
      <div class="w-full py-2">
        <router-link
          to="/auth/register"
          class="uppercase underline text-white font-neue text-xs lg:text-sm cursor-pointer"
        >
          No tengo cuenta </router-link
        ><br />
        <p
          class="text-white inline-block pt-2 pr-1 text-xs lg:text-sm uppercase"
        >
          ¿Olvidaste tu contraseña?
        </p>
        <a
          class="underline text-white text-xs lg:text-sm font-neue cursor-pointer"
          @click="showChangePassword()"
          >RECUPERAR</a
        >
      </div>
      <div class="action__content">
        <button
          class="login__button text-xs lg:text-sm text-white uppercase font-neue"
        >
          <span :class="{ spinner: loading == true }">INICIAR SESIÓN</span>
        </button>
      </div>
    </form>
    <ResetPassword v-else />
  </div>
</template>

<script>
import ButtonRed from "@/components/ui/ButtonRed";
import ResetPassword from "@/components/AuthComponents/ResetPassword";

export default {
  name: "LoginCustomer",
  components: {
    ButtonRed,
    ResetPassword,
  },
  data() {
    return {
      resetPassword: true,
      loading: false,
      user: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    changeStateInput(e) {
      if (e.target.value.length > 0) {
        e.target.classList.add("has-value");
      } else {
        e.target.classList.remove("has-value");
      }
    },
    showChangePassword() {
      this.resetPassword = false;
    },
    loginUser() {
      this.$validator
        .validateAll()
        .then((res) => {
          if (res) {
            if (this.loading) return;
            this.loading = true;
            this.$store
              .dispatch("login", this.user)
              .then(() => {
                this.$router.push(this.$route.query.redirect || "/dashboard");
              })
              .catch(() => {
                this.$swal({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  type: "error",
                  title: "Autenticación fallida",
                });
              })
              .then(() => {
                this.loading = false;
              });
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.login__title {
  font-size: 42px;
  color: #fff;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 400;
  text-align: left;
  line-height: 1;
  @media only screen and (min-width: 992px) {
    font-size: 55px;
  }
}
.input-group {
  position: relative;
  margin: 8px auto;
}
.login__content {
  width: 470px;
  display: flex;
  padding: 30px 20px;
  justify-content: flex-start;
  background-color: #73c9ff;
  @media only screen and (max-width: 992px) {
    width: 320px;
    padding: 30px 20px;
    justify-content: center;
  }
}
.form-control {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 25px;
  border: none;
  border-bottom: 1px solid lighten(black, 85%);
  background-color: transparent;
  color: var(--text-white);

  & + label {
    position: absolute;
    top: 10px;
    left: 3px;
    font-weight: bold;
    color: lighten(black, 60%);
    transition: all 0.2s ease-out;
    color: var(--main-blue);
  }

  &:focus {
    outline: none;
    border-width: 2px;
    border-color: 2px solid #0A50E6;
    transition: all 0.2s ease-out;
  }

  &:focus + label,
  &.has-value + label {
    top: -12px;
    color: var(--main-blue);
    font-size: 10px;
    font-weight: 300;
  }
}
input {
  border-bottom: 2px solid white;
  background: #73c9ff;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  font-size: 22px;
  color: white;
  &:focus {
    outline: none;
    border: 2px solid #0A50E6;
  }
}
.action__content {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
}
.login__button {
  width: 200px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0A50E6;
  color: #73c9ff;
  @media (min-width: 992px) {
    padding: 15px 0;
  }
}
h2 {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 43px;
  @media (min-width: 768px) {
    font-size: 32px;
  }
}
</style>
